import { styled } from 'styled-components';
const SmallHeader = styled.h4 `
  margin: 0;
  margin-bottom: 5px;
`;
export default SmallHeader;
//# sourceMappingURL=SmallHeader.js.map